exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".report-container---uim4_ {\n  padding-top: 12px;\n  border-top: 1px solid #e1e1e1; }\n  .report-container---uim4_ .legends---1FRl2 {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    margin-bottom: 12px; }\n  .report-container---uim4_ .legends---1FRl2 > div {\n      -webkit-box-flex: 0;\n          -ms-flex: 0 1 650px;\n              flex: 0 1 650px; }\n", ""]);

// exports
exports.locals = {
	"report-container": "report-container---uim4_",
	"legends": "legends---1FRl2"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./containers/activity-mastery/common/activity-mastery-legends/activity-mastery-legends.scss
// module id = /JVf
// module chunks = 1